import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Device } from '@rocksoft/shared';

@Component({
  selector: 'era-device-os-update-continue-ui',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-os-update-continue.component.html',
})
export class DeviceOsUpdateContinueComponent {
  public readonly device = input.required<Device>();
  public readonly continueClicked = output<Device>();

  public onContinue() {
    this.continueClicked.emit(this.device());
  }
}
